<template>
  <div>
    <div v-if="!loading">
      <h3 class="category-article" v-if="toCategory">
        <router-link :to="toCategory" class="text-decoration-none">
          {{ article.category.title }}
        </router-link>
      </h3>

      <div
        class="title-article grey--text text--darken-4 mt-3 mt-nd-6"
        v-if="article.title"
        v-html="article.title"
      ></div>

      <div class="date-article grey--text text--darken-1 mt-2" v-if="date">
        <v-icon class="mr-1"> far fa-calendar </v-icon>
        {{ date }}
      </div>

      <div class="mt-6">
        <v-responsive :aspect-ratio="16 / 9" v-if="embedVideo">
          <iframe
            width="100%"
            height="100%"
            fill-height
            :src="embedVideo"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </v-responsive>

        <img
          v-else-if="article.img && article.img.featured"
          :src="this.files + article.img.featured + '?resize=1&w=750'"
          :alt="article.title"
          width="100%"
        />

        <div
          class="grey--text text--darken-4 mt-2 text-small"
          v-if="article.img_description"
        >
          <i>{{ article.img_description }}</i>
        </div>
      </div>

      <div
        class="text-article grey--text text--darken-4 mt-6"
        v-if="article.text"
        v-html="article.text"
      ></div>

      <div
        class="source-article grey--text text--darken-2"
        v-if="article.source"
      >
        <b>Fonte:</b> {{ article.source }}
      </div>

      <div
        class="source-article grey--text text--darken-2"
        v-if="article.local"
      >
        <b>Local:</b> {{ article.local }}
      </div>
      <div
        class="source-article grey--text text--darken-2"
        v-if="article.author"
      >
        <b>Autor:</b> {{ article.author }}
      </div>
      <v-row>
        <v-col class="mt-5" cols="12">
          <share-buttons />
        </v-col>
      </v-row>
    </div>
    <v-sheet
      v-else
      class="d-flex justify-center align-center my-16"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>
  </div>
</template>

<script>
import ShareButtons from "@/components/widgets/ShareButtons.vue";
import { formatToURL, getYoutubeCode } from "@/components/utils";

export default {
  data: () => ({
    loading: true,
    article: [],
  }),
  props: {
    type: {
      type: String,
      default: "articles",
    },
    params: {
      type: Object,
    },
  },
  computed: {
    articleId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    toCategory() {
      if (!this.article.category) return "";
      return `/noticias/${formatToURL(this.article.category.title)}`;
    },
    embedVideo() {
      if (!this.$rest(this.type).item.link) return "";
      return `https://www.youtube.com/embed/${getYoutubeCode(
        this.article.link
      )}`;
    },
    date() {
      if (!this.article.date) return "";
      return this.formatDate(this.article.date);
    },
  },
  methods: {
    formatDate(date) {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "long" }).format(
        new Date(date.replace(" ", "T"))
      );
    },
    get() {
      this.loading = true;
      this.data = {};

      var params = {};
      if (this.params) params = this.params;

      this.$rest(this.type)
        .get({ id: this.articleId, params })
        .then((data) => {
          this.article = data;

          this.loading = false;
        })
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    articleId() {
      this.get();
    },
  },
  created() {
    this.get();

    navigator.sendBeacon(
      `${this.server}/rest/articles/${this.articleId}/view?type=${this.type}`
    );
  },
  components: {
    ShareButtons,
  },
};
</script>

<style scoped>
.category-article a {
  background-color: #2d4379;
  border-radius: 25rem;
  color: #ffffff;
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  line-height: 21px;
  padding: 3px 23px;
  transition: all 0.1s linear;
}

.category-article a:hover {
  opacity: 0.9;
}

.title-article {
  /* border-bottom: 3px solid var(--v-primary-base); */
  font-size: 32px !important;
  font-weight: 700;
  /* padding-bottom: 16px; */
}

@media (max-width: 1199px) {
  .title-article {
    font-size: 26px !important;
  }
}

@media (max-width: 700px) {
  .title-article {
    font-size: 18px !important;
  }
}

.source-article b {
  font-weight: 600;
}

.date-article .v-icon {
  font-size: 16px;
  vertical-align: baseline;
}

@media (max-width: 700px) {
  .date-article,
  .date-article .v-icon {
    font-size: 14px;
  }
}

.share-article {
  background-color: #3b5998;
  color: #ffffff;
  font-size: 14px;
}

.share-article .v-icon {
  font-size: 16px;
}

.share-article-item {
  letter-spacing: 0.2px;
}

.facebook-icon {
  color: #4267b2 !important;
}

.whatsapp-icon {
  color: #25d366 !important;
}

.twitter-icon {
  color: #1da1f2 !important;
}
</style>

<style>
.text-article iframe {
  aspect-ratio: 16 / 9 !important;
  display: block !important;
  height: 100% !important;
  width: 100% !important;
}
.text-article img {
  margin: 20px 0 !important;
  width: 100%;
}

.text-article img ~ .text-small {
  top: -15px;
  position: relative;
}

.text-article a * {
  color: var(--v-primary-base) !important;
}

.text-small {
  font-size: 80%;
}
</style>
